export default __webpack_public_path__ + "src/dataset/galleries-c901-8594c4.txt";